const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Reveal in elements with the .reveal class when they are in viewport.
 * Uses CSS transitions to handle the reveal in effect.
 */
const RevealAnimations = {

    /**
     * Delay between elements hitting the viewpoint at the same time
     */
    duration: 200,

    /**
     * Viewport offset before elements reveal in
     */
    offset: 0,

    init()
    {
        let vm = this;

        $(document).ready(function() {
            vm.revealElements();

            $window.on('scroll', function() {
                vm.revealElements();
            })

            $window.on('mwb/plugin/post_forms/added_posts', function() {
                $window.scroll();
            })
        })
    },

    revealElements()
    {
        let vm = this;
        let elementsToReveal = $('.reveal').not('.revealed, .revealing');
        let elementsToProcess = [];
        if (!elementsToReveal.length) return;
        elementsToReveal.each(function () {
            let element = $(this);
            if (vm.isInViewport(element)) elementsToProcess.push(element);
        });
        $.each(elementsToProcess, function (index, element) {
            element.addClass('revealing');
            setTimeout(function () {
                element.addClass('revealed').removeClass('revealing');
            }, index * vm.duration);
        });
    },

    isInViewport($element)
    {
        let elementTop = $element.offset().top;
        let elementBottom = elementTop + $element.outerHeight();
        let viewportTop = $window.scrollTop() + this.offset;
        let viewportBottom = viewportTop + $window.height() - this.offset;
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

};

export default RevealAnimations;